export const QUERY_KEYS = {
  GET_USER_ONBOARDING: 'GET_USER_ONBOARDING',
  GET_FILES: 'GET_FILES',
  GET_FILE_DETAIL: 'GET_FILE_DETAIL',
  GET_FILE_DETAIL_BY_ASSET_ID: 'GET_FILE_DETAIL_BY_ASSET_ID',

  GENERATE_PREVIEW: 'GENERATE_PREVIEW',

  GET_ENVELOPE_DETAILS: 'GET_ENVELOPE_DETAILS',
  GET_ACCOUNT: 'GET_ACCOUNT',

  UPDATE_STRIPE_CONFIGURATION: 'UPDATE_STRIPE_CONFIGURATION',

  GET_SUBSCRIPTION_DETAILS: 'GET_SUBSCRIPTION_DETAILS',

  GET_ACTUAL_SIGNING_LINK: 'GET_ACTUAL_SIGNING_LINK',

  CONNECT_STRIPE: 'CONNECT_STRIPE',

  DISCONNECT_STRIPE: 'DISCONNECT_STRIPE',
  GET_SIGNERS_SETTINGS: 'GET_SIGNERS_SETTINGS',
  GET_SIGNERS_DETAIL: 'GET_SIGNERS_DETAIL',
  GET_ENVELOPE_SIGNING_ORDER: 'GET_ENVELOPE_SIGNING_ORDER',

  GET_DEFAULT_LANGUAGE: 'GET_DEFAULT_LANGUAGE',
  GET_ACCOUNT_INFO_FOR_SIGNER: 'GET_ACCOUNT_INFO_FOR_SIGNER',
  EMAIL_VERIFICATION_OTP_ENABLED: 'EMAIL_VERIFICATION_OTP_ENABLED',

  // OTP Keys
  SEND_OTP: 'SEND_OTP',
  HAS_OTP_ENFORCED: 'HAS_OTP_ENFORCED',
  VERIFY_OTP: 'VERIFY_OTP',

  GET_FILES_FOR_SIGNER: 'GET_FILES_FOR_SIGNER',
  CHECK_PAYMENT_MADE: 'CHECK_PAYMENT_MADE',
  SIGNER_DOCUMENT_VIEWED: 'SIGNER_DOCUMENT_VIEWED',
  GET_ITEM_DETAILS_FOR_SIGNER: 'GET_ITEM_DETAILS_FOR_SIGNER',
  DOWNLOAD_CONTRACT: 'DOWNLOAD_CONTRACT',

  MONDAY_GET_ITEM_DETAILS: 'MONDAY_GET_ITEM_DETAILS',
  MONDAY_GET_BOARD_FIRST_ITEM: 'MONDAY_GET_BOARD_FIRST_ITEM',
  MONDAY_GET_SUB_ITEMS: 'MONDAY_GET_SUB_ITEMS',
  MONDAY_GET_SUBITEM_BOARD_PARENT: 'MONDAY_GET_SUBITEM_BOARD_PARENT',
  MONDAY_GET_BOARD_ITEM_WITH_NONEMPTY_COLUMN:
    'MONDAY_GET_BOARD_ITEM_WITH_NONEMPTY_COLUMN',
  MONDAY_HYDRATE_LINKED_ITEM_FORMULAS: 'MONDAY_HYDRATE_LINKED_ITEM_FORMULAS',

  GET_TEMPLATE_DETAILS: 'GET_TEMPLATE_DETAILS',
  GET_TEMPLATE_FILE_CONTENT: 'GET_TEMPLATE_FILE_CONTENT',
  GET_SOURCE_BOARD_FIELDS: 'GET_SOURCE_BOARD_FIELDS',

  DETECT_PLACEHOLDERS_AI: 'DETECT_PLACEHOLDERS_AI',
  HAS_SIGNER_SIGNED: 'HAS_SIGNER_SIGNED',

  // Form Keys
  GET_FORM_DETAIL: 'GET_FORM_DETAIL',
  GET_FORM_DETAIL_SIGNERS: 'GET_FORM_DETAIL_SIGNERS',

  // Superadmin Keys
  SUPERADMIN_ME: 'SUPERADMIN_ME',
  SUPERADMIN_ACCOUNTS: 'SUPERADMIN_ACCOUNTS',
  SUPERADMIN_ACCOUNT_DETAIL: 'SUPERADMIN_ACCOUNT_DETAIL',
  SUPERADMIN_ACCOUNT_BOARDS: 'SUPERADMIN_ACCOUNT_BOARDS',
  SUPERADMIN_BOARD_ENVELOPES: 'SUPERADMIN_BOARD_ENVELOPES',
  SUPERADMIN_BOARD_WEBHOOKS: 'SUPERADMIN_BOARD_WEBHOOKS',
};
